export default __webpack_public_path__ + "static/media/hoverLine.f77ed09d.svg";